var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Student Surveys",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      subtitle: _vm.allLocations
                        ? "Surveys By Location"
                        : `${_vm.selectedLocation.name} Surveys`,
                      allLocations: _vm.allLocations,
                      locationOptions: "",
                      selectedLocation: _vm.selectedLocation,
                      filter: "",
                      dateRange: _vm.dateRange,
                      reportUrl: "/dashboard/reports/student-surveys",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.loading,
                      headers: _vm.headers,
                      items: _vm.surveys,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      search: _vm.search,
                      groupBy: _vm.allLocations ? "location" : null,
                    },
                    on: {
                      "current-items": function ($event) {
                        return _vm.collapse()
                      },
                      "click:row": function ($event) {
                        ;[_vm.$log($event.id), _vm.getSurvey($event.id)]
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ group, items, isOpen, toggle }) {
                            return [
                              _c(
                                "th",
                                { attrs: { colspan: "7" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "flex justify-start align-center pa-2",
                                      attrs: { "no-gutters": "" },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-3",
                                          on: { click: toggle },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(isOpen ? "remove" : "add") +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "soli-grey text-subtitle-2 font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(group) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "soli-grey text-small",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        • " +
                                                _vm._s(items.length) +
                                                " Survey(s)\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.info.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center py-2 soli-grey",
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      item.info.user_id
                                        ? _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.info.user_id}/account`,
                                              },
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.info.name) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.info.name) +
                                                "\n                                "
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.info.email) +
                                              "\n                                    "
                                          ),
                                          _c("Clipboard", {
                                            attrs: {
                                              text: item.info.email,
                                              label: "Copy Email",
                                              "x-small": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.date`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.date) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSurveyDetails
        ? _c("SoliResponsiveDialog", {
            attrs: {
              title: _vm.showSurveyDetails.user.name,
              subtitle: _vm.showSurveyDetails.user.email,
              size: "700",
            },
            on: {
              reset: function ($event) {
                _vm.showSurveyDetails = null
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-simple-table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("Question"),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-left" }, [
                              _vm._v("Response"),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [_vm._v("Recommend Us?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.showSurveyDetails.recommend_us)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showSurveyDetails.recommend_us_reason
                            ? _c("tr", [
                                _c("td", [_vm._v("Reason")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.showSurveyDetails.recommend_us_reason
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Recommend Teacher?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.showSurveyDetails.recommend_teacher)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showSurveyDetails.recommend_teacher_reason
                            ? _c("tr", [
                                _c("td", [_vm._v("Reason")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .recommend_teacher_reason
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Hear about us?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.showSurveyDetails.hear_about_us)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showSurveyDetails.hear_about_us_detail
                            ? _c("tr", [
                                _c("td", [_vm._v("Hear about us details")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .hear_about_us_detail
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSurveyDetails.hear_about_us_other
                            ? _c("tr", [
                                _c("td", [_vm._v("Hear about us other")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .hear_about_us_other
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("What's most important?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.showSurveyDetails.most_important
                                      .map((e) => e)
                                      .toString()
                                      .replace(/,/g, ", ")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showSurveyDetails.most_important_specific_goal
                            ? _c("tr", [
                                _c("td", [_vm._v("Specific goal")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .most_important_specific_goal
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSurveyDetails.most_important_other
                            ? _c("tr", [
                                _c("td", [_vm._v("Most important other")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .most_important_other
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Are we delivering?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.showSurveyDetails.are_we_delivering
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("What's least important?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.showSurveyDetails.least_important
                                      .map((e) => e)
                                      .toString()
                                      .replace(/,/g, ", ")
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.showSurveyDetails.least_important_specific_goal
                            ? _c("tr", [
                                _c("td", [_vm._v("Specific goal")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .least_important_specific_goal
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showSurveyDetails.least_important_other
                            ? _c("tr", [
                                _c("td", [_vm._v("Least important other")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showSurveyDetails
                                          .least_important_other
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("What can we do better?")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.showSurveyDetails.do_better) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("td", [_vm._v("Source")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.showSurveyDetails.source) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3562088224
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }